import { Octicons } from '@expo/vector-icons';
import React from 'react';
import { ImageRequireSource } from 'react-native';
import styled from 'styled-components/native';
import Colors from '../constants/Colors';
import { B } from './Typography';

const StyledContainer = styled.View`
  height: 165px;
  width: 158px;
  border-radius: 12px;
  padding: 10px 11px 10px 11px;
  background-color: #d5c7ff;
`;

const StyledImage = styled.Image`
  height: 90px;
  width: 135px;
  border-radius: 12px;
`;

const StyledTitleText = styled(B)`
  font-size: 14px;
  line-height: 16px;
  color: ${Colors.primary};
  margin-top: 11px;
`;

const StyledHorizontalContainer = styled.View`
  flex-direction: row;
  margin-top: 5px;
`;

const StyledIconContainer = styled.View`
  margin-top: 6px;
  padding-right: 5px;
`;

const StyledDescriptionText = styled.Text`
  font-family: 'WorkSans-Medium';
  font-size: 12px;
  line-height: 14px;
  color: #5b4fc2;
  margin-top: 5px;
`;

export interface StudyNotificationCardProps {
  image: string | ImageRequireSource;
  title: string;
  description: string;
}

const StudyNotificationCard: React.FC<StudyNotificationCardProps> = ({
  image,
  title,
  description
}) => {
  return (
    <StyledContainer>
      <StyledImage
        source={typeof image === 'string' ? { uri: image } : image}
      />
      <StyledTitleText>{title}</StyledTitleText>
      <StyledHorizontalContainer>
        <StyledIconContainer>
          <Octicons name='pulse' size={17} color='#5B4FC2' />
        </StyledIconContainer>
        <StyledDescriptionText>{description}</StyledDescriptionText>
      </StyledHorizontalContainer>
    </StyledContainer>
  );
};
export default StudyNotificationCard;
